module.exports = __webpack_public_path__ + "static/img/dingzhirongzi.68feb8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom/dingzhirongzi.png
// module id = i0u/
// module chunks = 1